/**
 * 救济金
 */

import { request } from '@/utils/request';

/** 获取救济金信息 */
export const getDoleDetail = () =>
  request({
    url: '/gamer/query_jjj_pe',
    method: 'GET'
  });

/** 领取救济金 */
export const receiveDole = () =>
  request({
    url: '/gamer/take_jjj_pe',
    method: 'GET'
  });
